/**
 * Formate un nombre avec séparateurs de milliers et décimales.
 *
 * @param value - La valeur à formater (number, string, null, undefined)
 * @param decimals - Nombre de décimales (défaut: 2)
 * @param locale - Locale pour le formatage (défaut: 'fr-FR')
 * @returns La valeur formatée en string, ou '' si la valeur est null/undefined/NaN
 *
 * @example
 * formatNumber(10000)        → "10 000,00"
 * formatNumber(1500.5)       → "1 500,50"
 * formatNumber(1500.5, 0)    → "1 501"
 * formatNumber(null)         → ""
 * formatNumber("2.5")        → "2,50"
 * formatNumber("abc")        → ""
 */
export const formatNumber = (
  value: number | string | null | undefined,
  decimals: number = 2,
  locale: string = 'fr-FR'
): string => {
  if (value === null || value === undefined || value === '') return '';
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) return '';
  return num.toLocaleString(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

/**
 * Parse une valeur formatée (avec espaces et virgules) en nombre.
 * Utile pour récupérer la valeur numérique depuis un input formaté.
 *
 * @example
 * parseFormattedNumber("10 000,50") → 10000.50
 * parseFormattedNumber("1 500")     → 1500
 */
export const parseFormattedNumber = (
  value: string | null | undefined
): number | null => {
  if (!value) return null;
  // Supprimer les espaces (séparateurs milliers fr-FR) et remplacer virgule par point
  const cleaned = value.replace(/\s/g, '').replace(',', '.');
  const num = parseFloat(cleaned);
  return isNaN(num) ? null : num;
};
